import { Cloudinary } from "@cloudinary/base"
import { datadogRum } from "@datadog/browser-rum"
import CssBaseline from "@material-ui/core/CssBaseline"
import { MuiThemeProvider } from "@material-ui/core/styles"
import * as Sentry from "@sentry/react"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import "rc-slider/assets/index.css"
import React from "react"
import ReactDOM from "react-dom/client"
import { initDB } from "react-indexed-db"
import { QueryClient, QueryClientProvider } from "react-query"
import { BrowserRouter } from "react-router-dom"
import App from "~/components/App"
import "./styles/base.css"
import theme from "./themes/main"

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://27dbf8d75b2161de7310aeaa8d3385be@o4508654057029632.ingest.us.sentry.io/4508763675164672",
    integrations: [],
  })
}

// adds duration plugin to dayjs
dayjs.extend(duration)

datadogRum.init({
  applicationId: "f7863e38-da59-4b53-9f8c-5c3dcae8d6b4",
  clientToken: "pub80090a6684a2444fc62ac2692e4641c6",
  site: "us5.datadoghq.com",
  service: "admin.dataprotocol.com",
  env: import.meta.env.VITE_ENV,
  version: import.meta.env.VITE_RELEASE_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
})

export const cloudinary = new Cloudinary({
  cloud: {
    cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  },
  url: {
    secure: true,
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
    },
    refetchOnWindowFocus: true,
  },
})

initDB({
  name: "data-protocol-admin-auth",
  version: 1,
  objectStoresMeta: [
    {
      store: "auth",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "token", keypath: "token" },
        { name: "account", keypath: "account" },
      ],
    },
  ],
})
// strict mode is commented out because react-beautiful-dnd does not support it
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </MuiThemeProvider>
  </BrowserRouter>,
  // </React.StrictMode>,
)
